module.exports = __webpack_public_path__ + "img/phonebottom.f2d09534.png";